/** @format */

import React from "react";
import { Box } from "../../components/layouts/Box";
import { Container } from "../../components/layouts/Container";
import { TitleElement } from "../../components/ui_elements";
import useStartHooks from "../../hooks/useStartHooks";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";
import { BackButton, PdfExplainBox } from "../../components/ui-parts";

import { BcartUseStartElement, BcartUseStartLinkElement } from "../../components/ui_elements";

const UseStart = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const {
    useStartData,
    serviceCodeList,
    serviceStatusData,
    economicInfoData,
    creditBrandData,
    serviceStopFlag,
    zMaster,
  } = useStartHooks(navigateByAgent);
  return (
    <Container isLogin={true}>
      <TitleElement />
      <div className="mb12 align_right display-mobile">
        <BackButton onClick={() => navigateByAgent("/dashboard")}>ダッシュボードに戻る</BackButton>
      </div>
      <BcartUseStartElement
        managementData={useStartData.managementData}
        serviceData={useStartData.serviceData}
        serviceCodeList={serviceCodeList}
        serviceStatusData={serviceStatusData}
        economicInfoData={economicInfoData}
        creditBrandData={creditBrandData}
        serviceStopFlag={serviceStopFlag}
        zMaster={zMaster}
      />
      <Box mt={20} />
      <PdfExplainBox />
      <BcartUseStartLinkElement />
    </Container>
  );
};

export default UseStart;
